module.exports = __webpack_public_path__ + "static/media/ipad_reporting_rounded_corners.cd44ef16.png";